export const THEMES = {
  ocean: {
    name: "Ocean",
    primary: "#60a5fa",
    secondary: "#2dd4bf",
    accent: "#3b82f6",
    bg: "#020617",
    grid: "rgba(59, 130, 246, 0.3)",
  },
  cyber: {
    name: "Cyber",
    primary: "#f0abfc",
    secondary: "#3b82f6",
    accent: "#d946ef",
    bg: "#020617",
    grid: "rgba(217, 70, 239, 0.3)",
  },
  emerald: {
    name: "Emerald",
    primary: "#34d399",
    secondary: "#10b981",
    accent: "#059669",
    bg: "#020617",
    grid: "rgba(16, 185, 129, 0.3)",
  },
};

export const DEFAULT_THEME_KEY = "ocean";
